<template>
  <v-container>
    <v-card class="mx-auto" min-width="384px" max-width="512px">
      <v-card-title class="blue-grey white--text">
        <h3>{{userId}}</h3>
      </v-card-title>
      <v-tabs v-model="activeTab">
        <v-tab key="1">Properties</v-tab>
        <v-tab key="2">Advanced</v-tab>
        <v-tab-item>
          <v-card-text>
            <v-form ref="form" v-model="isFormValid" lazy-validation>
              <v-text-field label="Display name" v-model="displayName" prepend-icon="mdi-label" />
              <v-radio-group v-model="accessLevel" label="Access level" row>
                <v-radio label="None" value="None"></v-radio>
                <v-radio label="User" value="User"></v-radio>
                <v-radio label="Administrator" value="Admin"></v-radio>
              </v-radio-group>
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                v-model="newPassword"
                :rules="newPasswordRules"
                label="New password (leave empty to keep the existing one)"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn @click="validate" color="info" :disabled="!isFormValid">
              <v-icon>mdi-content-save</v-icon>Save
            </v-btn>
            <v-btn @click="close()" color="orange white--text">
              <v-icon>mdi-cancel</v-icon>Cancel
            </v-btn>
            <v-btn @click="reset" color="deep-purple white--text">
              <v-icon>mdi-restore</v-icon>Reset
            </v-btn>
          </v-card-actions>
        </v-tab-item>
        <v-tab-item key="2">
          <v-card-text>
            <v-form ref="removeForm" v-model="isRemoveFormValid" lazy-validation>
              <v-text-field
                label="To remove this user, retype here the username"
                v-model="removeUserName"
                :rules="removeUserNameRules"
                prepend-icon="mdi-account-remove"
              />
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn @click="remove" color="red white--text" :disabled="!isRemoveFormValid">
              <v-icon>mdi-delete</v-icon>Account removal
            </v-btn>
          </v-card-actions>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<style scoped>
.v-list-item {
  min-height: 0px;
}
.v-dialog.v-dialog--active .v-card__title {
    cursor: grab;
}
.v-dialog.v-dialog--active .v-card__title:active {
    cursor: grabbing;
}
</style>

<script>
export default {
  name: "User",
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {},
  data: () => ({
    userId: null,
    activeTab: 0,
    tabs: [
      { id: 1, name: "tab1" },
      { id: 2, name: "tab2" }
    ],
    isFormValid: false,
    isRemoveFormValid: false,
    newPassword: "",
    newPasswordRules: [v => /^(.{8,})?$/.test(v) || "Password must be valid"],
    removeUserNameRules: [v => !!v || "Value required"],
    showPassword: false,
    removeUserName: "",
    accessLevel: "",
    displayName: ""
  }),
  watch: {
    id: function(value) {
      this.load(value);
    }
  },
  created() {
    this.load(this.id);
  },
  methods: {
    reset() {
      this.load(this.userId);
    },
    load(id) {
      this.userId = id;
      this.activeTab = 0;
      this.removeUserName = "";
      this.$axios
        .get("/users/" + this.userId)
        .then(result => {
          this.displayName =
            result.data.display_name ||
            this.userId
              .replace(/(\.prestataire)?@.*/, "")
              .split(".")
              .map(w => w[0].toUpperCase() + w.slice(1))
              .join(" ");
          this.accessLevel = result.data.access_level;
        })
        .catch(result => {
          this.processErrorResponse(result);
          this.close();
        });
    },
    processErrorResponse(result) {
      this.$emit("error", result);
    },
    validate() {
      if (this.$refs.form.validate()) {
        var data = {
          display_name: this.displayName != "" ? this.displayName : null,
          access_level: this.accessLevel
        };
        if (this.newPassword != "") {
          data["password"] = this.newPassword;
        }
        this.$axios
          .put("/users/" + this.userId, data)
          .then(() => {
            this.$emit("success", "Configuration successfully updated");
            this.close({
              type: "update",
              data: {
                id: this.userId,
                displayName: this.displayName || this.userId,
                accessLevel: this.accessLevel
              }
            });
          })
          .catch(result => {
            this.processErrorResponse(result);
          });
      }
    },
    remove() {
      if (this.$refs.removeForm.validate()) {
        if (this.removeUserName !== this.userId) {
          this.processErrorResponse(
            "The value doesn't match with the current user ID"
          );
          return;
        }
        this.$axios
          .delete("/users/" + this.userId)
          .then(() => {
            this.$emit("success", "User successfully removed");
            this.close({ type: "delete" });
          })
          .catch(result => {
            this.processErrorResponse(result);
          });
      }
    },
    close(data) {
      this.$emit("close", data);
    }
  }
};
</script>
